module.exports = __webpack_public_path__ + "static/media/theme-colorful-no-drop-targets.9cc5fce9.svg";